<template>
  <div class="card occ-actions mt-3">
    <div class="card-header py-2">
      <span class="font-weight-bold">
        <feather-icon
          icon="ZapIcon"
          size="15"
          class="mr-50"
        />
        Botões de ação
      </span>
    </div>
    <div class="card-body py-2 d-flex justify-content-end flex-wrap occ-actions__buttons">
      <button
        type="button"
        class="btn btn-sm btn-outline-secondary"
        @click="$emit('back')"
      >
        <feather-icon
          icon="ArrowLeftIcon"
          size="13"
          class="mr-25"
        />
        {{ $t('common.back') }}
      </button>
      <button
        v-if="canFinalize"
        type="button"
        class="btn btn-sm btn-outline-success"
        @click="$emit('finalize')"
      >
        <feather-icon
          icon="CheckCircleIcon"
          size="13"
          class="mr-25"
        />
        Finalizar
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OccurrenceActionsBar',

  props: {
    canFinalize: { type: Boolean, default: false },
  },
}
</script>

<style scoped>
.occ-actions__buttons {
  gap: 8px;
}
</style>
